import { render, staticRenderFns } from "./DonutStatPerSiteChart.vue?vue&type=template&id=f04c7a9e"
import script from "./DonutStatPerSiteChart.vue?vue&type=script&lang=js"
export * from "./DonutStatPerSiteChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports